import * as React from 'react';
import { inject, observer } from "mobx-react";
import { AppProps } from "../../stores/storeContract";
import './Loader.scss';

@inject("symbolStore", "settingsStore", "filterStore")
@observer
export default class Loader extends React.Component<AppProps> {

	render() {

        const inProgressSymbols = this.props.symbolStore.inProgress;
        const inProgressSettings = this.props.settingsStore.inProgress;
        const inProgressFilters = this.props.filterStore.inProgress;

        var inProgress = inProgressSymbols || inProgressSettings || inProgressFilters;

        return (
            <div className={inProgress ? 'loader-container' : 'hidden'}>
                <div className={inProgress ? 'lds-roller loader-center' : 'hidden'}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        );
	}
}
